import { useState } from 'react';
import TimeSlots from '../../components/Calendar/TimeSlots';
import StyledCol from '../../components/Cols/StyledCol';
import Calendar, { IFinishedSolution } from '../Calendar/Calendar';
import { LeftDiv } from '../Div/StyledDiv';
import { StyledRowNoMargin } from '../Rows/StyledRow';

//test commit
const AppointmentCalendar = () => {
    const [selectedDay, setSelectedDay] = useState<string>('');
    const [finishedSolution, setFinishedSolution] = useState<IFinishedSolution | undefined>(undefined);

    return (
        <LeftDiv marginBottom="30px">
            <StyledRowNoMargin xs={1} sm={2}>
                <StyledCol paddingLeft="0px">
                    <Calendar setSelectedDay={setSelectedDay} setFinishedSolution={setFinishedSolution} />
                </StyledCol>
                <StyledCol>
                    <TimeSlots selectedDay={selectedDay} finishedSolution={finishedSolution} />
                </StyledCol>
            </StyledRowNoMargin>
        </LeftDiv>
    );
};

export default AppointmentCalendar;
